/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * The typed confirmation of a superadmin purge.
 * @export
 * @interface OrganizationPurge
 */
export interface OrganizationPurge {
    /**
     * The organization's exact name (surrounding spaces ignored)
     * @type {string}
     * @memberof OrganizationPurge
     */
    name: string;
}

/**
 * Check if a given object implements the OrganizationPurge interface.
 */
export function instanceOfOrganizationPurge(value: object): value is OrganizationPurge {
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function OrganizationPurgeFromJSON(json: any): OrganizationPurge {
    return OrganizationPurgeFromJSONTyped(json, false);
}

export function OrganizationPurgeFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrganizationPurge {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
    };
}

export function OrganizationPurgeToJSON(json: any): OrganizationPurge {
    return OrganizationPurgeToJSONTyped(json, false);
}

export function OrganizationPurgeToJSONTyped(value?: OrganizationPurge | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
    };
}

